import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosAsync, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { formatearLabel } from '../../funciones_globales/format';

const ContenedorBoton = styled.div`
  padding-top: 17px;  
  @media (max-width: 991px) {
    padding-top: 0px;
  }
`;

class FormCli15 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global
            cliente_sel: null,
            banco_sel: null,
            cuenta: "",
            cuentaOriginal: "",
            secuencia: "",
            girador: "",
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar

            gridCuentas: [],                
            columnDefsCuentas:[ 
                                {   header: "Sec",
                                    field: "Secuencia",
                                    width: 50,
                                    type: "string"                                                 
                                },   
                                {   header: "Banco",
                                    field: "BancoDescripcion",
                                    width: 120,
                                    type: "string"                                                 
                                },
                                {   header: "Cuenta",
                                    field: "Cuenta",
                                    width: 120,
                                    type: "string"                                                 
                                }, 
                                {   header: "Girador",
                                    field: "Girador",
                                    width: 250,
                                    type: "string"                                                 
                                },  
                                {   header: "",
                                    field: "eliminar",
                                    width: 60,
                                    type: "link_elim"                                                
                                },                               
                            ],
        };

        //GRID OPTIONS
        this.cuentasOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDataChanged:((event)=>{
            }),
            onCellValueChanged:((event)=>{  
            }),
            onCellEditingStarted:((event)=> {
            }),
            onRowDoubleClicked: ((event)=>{
                if(this.state.banco_sel || this.state.cuenta!=="" || this.state.girador !== "" ){
                    alert(' - Se encuentra añadiendo una cuenta, añadala o limpie para continuar')
                }else{
                    let fila = event.data

                    this.setState({banco_sel: {value: fila.Banco, label: fila.BancoDescripcion}, 
                        cuenta: fila.Cuenta, girador: fila.Girador, cuentaOriginal: fila.Cuenta, secuencia: fila.Secuencia, operacion: 'M'}, ()=>{
                            this.setState({gridCuentas: this.immutableDelete(this.state.gridCuentas, event.rowIndex)})
                    })
                }
            })
        };
        this.getCuentaPorCliente = this.getCuentaPorCliente.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.addCuenta = this.addCuenta.bind(this);
        this.clearCuenta = this.clearCuenta.bind(this);
        this.guardarCuentasCliente = this.guardarCuentasCliente.bind(this);

        //GRID
        this.onGridCuentasReady = this.onGridCuentasReady.bind(this);
    }

    //GRID
    onGridCuentasReady(params){
        this.apiCuentas = params.api;
        this.columnApiCuentas = params.columnApi;
    }

    //Op Arrays Inmutables
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({[name]: value});
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0115').then(()=>{
            this.setState({permiso: this.props.permiso})
        })
        .catch((error)=>{

        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0115');
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 3 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;     
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Banco(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('BANCO', input, callback)
        }
    }

    addCuenta(){
        if(this.state.banco_sel && this.state.cuenta!=="" && this.state.girador !== "" && this.state.cliente_sel){
            let item = {};

            item.Cliente = this.state.cliente_sel.value;
            item.Secuencia = this.state.gridCuentas.length + 1;
            item.Banco = this.state.banco_sel.value;
            item.BancoDescripcion = formatearLabel(this.state.banco_sel.label);
            item.Cuenta = this.state.cuenta;
            item.usuario = this.props.usuario;
            item.Terminal = "";
            item.FechaSistema = "";
            item.Estado = "A";
            item.Girador = this.state.girador.toString().toUpperCase();

            this.setState({ gridCuentas: this.immutablePush(this.state.gridCuentas, item) }
            ,()=>{
                this.clearCuenta();
            })
        }else{
            alert('- Verifique que halla ingresado banco, cuenta y girador antes de añadir la cta.')
        }
    }

    clearCuenta(){
        this.setState({banco_sel: null, cuenta: "", girador: "", secuencia: "", cuentaOriginal: "" })
    }

    limpiarPantalla(param){
        if(param === 'A'){
            this.setState({cliente_sel: null})
        }
        this.clearCuenta();
        this.setState({gridCuentas: [], operacion: 'G'});
    }

    //SQL
    getCuentaPorCliente(){
        if(this.state.cliente_sel){
            let config_request = {
                method: 'GET',
                url: '/clientes/'+this.state.cliente_sel.value+'/cuentasbancarias'
            }
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                console.log('RESP: ', response)
                let data = response.data;

                let array = this.formatGridCuentas(data);

                if(data.length > 0){
                    this.setState({gridCuentas: array});
                }else{
                    this.setState({gridCuentas: array});
                }
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert("Ha ocurrido un error: " + error);
            })
        }else{
            alert('Seleccione un cliente para continuar...')
        }
    }

    formatGridCuentas(array){
        let resultArray = [];
        if(array.length > 0){
            array.forEach((CTAS)=>{
                let item = {};

                item.Cliente = CTAS.Cliente;
                item.Secuencia = CTAS.Secuencia;
                item.Banco = CTAS.Banco;
                item.BancoDescripcion = CTAS.infoBanco?CTAS.infoBanco.Descripcion:'N/A';
                item.Cuenta = CTAS.Cuenta;
                item.CuentaOriginal = CTAS.Cuenta;
                item.usuario = this.props.usuario;
                item.Terminal = "";
                item.FechaSistema = "";
                item.Estado = "A";
                item.Girador = CTAS.Girador?CTAS.Girador.toString().toUpperCase():"N/A";

                resultArray.push(item);
            })
        }
        return resultArray;
    }

    guardarCuentasCliente(){
        var errors = "";
        var proceder = true;
        var data = {};

        if(!this.state.cliente_sel){
            proceder = false;
            errors += '- Seleccione un cliente para continuar\n'
        }

        if(this.state.banco_sel && this.state.cuenta!=="" && this.state.girador !== ""){
            errors +='- Verifique que halla ingresado banco, cuenta y girador antes de añadir la cta.';
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }
        console.log('OPERACION: ', this.state.operacion)
        if(proceder === true){
            data.Cliente = this.state.cliente_sel.value;
            data.Banco = this.state.banco_sel.value;
            data.BancoDescripcion = formatearLabel(this.state.banco_sel.label);
            data.Cuenta = this.state.cuenta;
            
            if(this.state.operacion === 'M'){
                data.CuentaOriginal = this.state.cuentaOriginal;
                data.Secuencia = this.state.secuencia;
            }
            
            data.Usuario = this.props.usuario;
            data.Terminal = this.props.idRegAudit;
            
            if(this.state.operacion === 'G'){
                data.FechaSistema = "";
            }
            
            data.Estado = "A";
            data.Girador = this.state.girador.toString().toUpperCase();

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: '/clientes/'+this.state.cliente_sel.value+'/cuentasbancarias',
                data
            }

            global_axios(config_request)
            .then((response)=> {
                console.log(response)
                alert(response.data.msg)
                this.limpiarPantalla('B');
                this.getCuentaPorCliente();
            })
            .catch((error)=>{
                this.getCuentaPorCliente();
                alert(error.response?error.response.data.msg:error.message);
            })

        }else{
            alert(errors);
        }
    }

    //OK
    deleteCuentasCliente(fila){
        var errors = "";
        var proceder = true;

        if(!this.state.cliente_sel){
            proceder = false;
            errors += '- Seleccione un cliente para continuar\n'
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(proceder === true){

            let config_request = {
                method: 'DELETE',
                url: '/clientes/'+this.state.cliente_sel.value+'/banco/'+fila.Banco+'/cuenta/'+fila.Cuenta,
                headers: {'idregaudit': this.props.idRegAudit, 'operacion': this.props.usuario}
            }

            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=> {
                this.props.cambiar_VisualizacionLoading(false);
                console.log(response)
                alert(response.data.msg)
                this.limpiarPantalla('B');
                this.getCuentaPorCliente();
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors);
        }
    }

    methodFromParent(id, datos_fila){
        let mensaje = window.confirm('¿Eliminar siguiente registro?')

        if(mensaje){
            this.deleteCuentasCliente(datos_fila)
        }
    }

    render(){
        return(
            <ContenedorForm porc_ancho={50}>
             <HeaderForm>
                <TituloForm>Matriculación de Cuentas</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='2' alto='45'>
                        <Row>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Cliente:</LabelForm>
                            </ContainerCol>

                            <ContainerCol className='col-sm-7'>
                                <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({cliente_sel: value })}}
                                func_onBlur={this.getCuentaPorCliente}/>
                            </ContainerCol>
                        </Row>                        
                    </ContainerEdit>

                    <Row margen_arriba="10">
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Banco:</LabelForm>  
                            <ReactSelectAsync value={this.state.banco_sel} func_loadOptions={this.getOptions_Banco}
                            func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({banco_sel: value?value:null});}}/>    
                        </ContainerCol>

                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Cuenta:</LabelForm>
                            <InputText autoComplete='off' name="cuenta" value={this.state.cuenta} onChange={this.actualizarCampos} maxLength={20}/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-4'>
                            <div className='input-group'>
                                <LabelForm>Girador:</LabelForm>
                                <InputText autoComplete='off' name="girador" value={this.state.girador} onChange={this.actualizarCampos} maxLength={50}/>
                            </div>
                        </ContainerCol>

                        <ContainerCol className='col-sm-2'>
                            <ContenedorBoton>
                                <Tooltip placement='right' overlay='Añadir/Limpiar una cuenta'>
                                    <div className='btn-group pull-left'>
                                        <button type='button' className='btn btn-success btn-sm' onClick={this.guardarCuentasCliente}><i className='fa fa-plus'></i></button>
                                        <button type='button' className='btn btn-danger btn-sm' onClick={this.clearCuenta}><i className='fa fa-trash-o fa-lg'></i></button>                                
                                    </div>
                                </Tooltip>
                           </ContenedorBoton>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <AgGridRender altura='148px' data={this.state.gridCuentas} columnas={this.state.columnDefsCuentas} 
                            gridOptions={this.cuentasOptions} onGridReady={this.onGridCuentasReady}/> 
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
        }
  });
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
        cambiar_VisualizacionLoading }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCli15);